// 用户模块管理
<template>
    <div class="jobs">
        <div class="screening">
            <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item title="筛选框" name="1">
                    <div class="screening-out">
                        <el-form :inline="true" :model="searchFrom" class="demo-form-inline">
                            <el-row>
                                <el-col :span="22">
                                    <el-form-item label="模块名称">
                                        <el-input v-model="searchFrom.name" placeholder="请输入需要查询的模块名称" size="mini"></el-input>
                                    </el-form-item>
                                    <!-- <el-form-item label="所属部门">
                                        <el-input v-model="searchFrom.name" placeholder="请输入需要查询的部门名称"></el-input>
                                    </el-form-item> -->
                                    <el-form-item label="创建时间">
                                        <el-date-picker
                                            v-model="valueTime"
                                            type="datetimerange"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            clearable
                                            value-format="YYYY-MM-DD HH:mm:ss"
                                            size="mini"
                                            :default-time="defaultTime">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="2">
                                    <!-- <el-form-item> -->
                                        <div class="title-buttom">
                                            <el-button class="cancel" size="mini" @click="reset" round>重置</el-button>
                                            <el-button type="primary" size="mini" class="confirmAdd" @click="getDataList(true)" round>查询</el-button>
                                        </div>
                                    <!-- </el-form-item> -->
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <el-row>
            <el-col :span="12">
                <div class="title-name">
                    模块列表
                </div>
            </el-col>
            <el-col :span="12">
                <div class="title-buttom">
                    <el-tooltip content="刷新列表" placement="top" effect="light">
                        <el-button class="editor" size="mini" icon="el-icon-refresh-right" @click="reset" circle></el-button>
                    </el-tooltip>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <div>
                    <el-table
                    v-loading="loading"
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    :header-cell-style="{background:'#e0e5ff',color:'#24252F'}"
                    @selection-change="handleSelectionChange">
                        <!-- <el-table-column
                        type="selection"
                        width="55">
                        </el-table-column> -->
                        <el-table-column
                        label="昵称">
                        <template #default="scope">{{ scope.row.user == null?'-': scope.row.user.nickname}}</template>
                        </el-table-column>
                        <el-table-column
                        label="手机号">
                        <template #default="scope">{{ scope.row.user == null?'-': scope.row.user.phone}}</template>
                        </el-table-column>
                        <el-table-column
                        label="拥有模块">
                        <template #default="scope">
                            <el-tag>{{ scope.row.app == null?'-': scope.row.app.name}}</el-tag>
                        </template>
                        </el-table-column>
                        <el-table-column
                        label="模块价格">
                        <template #default="scope">
                            <span>￥{{ scope.row.app == null?'-': scope.row.app.price}}</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        label="模块到期时间">
                        <template #default="scope">{{ scope.row.expireTime == null?'-': scope.row.expireTime}}</template>
                        </el-table-column>
                        <el-table-column
                        label="正常/封禁">
                        <template #default="scope">
                            <el-tag type="success" v-if="scope.row.status == 0">{{ scope.row.statusText == null?'-': scope.row.statusText }}</el-tag>
                            <el-tag type="danger" v-else>{{ scope.row.statusText == null?'-': scope.row.statusText }}</el-tag>
                        </template>
                        </el-table-column>
                        <!-- <el-table-column
                        label="启用/禁用" align="center">
                        <template #default="scope">
                            <a-switch 
                                size="small" 
                                v-model:checked="scope.row.status" 
                                :checkedValue="0"
                                :unCheckedValue="1"
                                @click="onSwitch(scope.row, scope.row.status)" 
                            />
                        </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template #default="scope">
                                <el-tooltip content="编辑模块" placement="top" effect="light">
                                    <el-button class="editor" size="mini" icon="el-icon-edit" @click="modify(scope.row)" round></el-button>
                                </el-tooltip>
                                <el-tooltip content="删除模块" placement="top" effect="light">
                                        <el-button class="deletetable" size="mini" icon="el-icon-delete" @click="confirmEvent(scope.row.id)" round></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column> -->
                    </el-table>
                </div>
            </el-col>
        </el-row>
        <div class="pager">
            <div>
               <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                background
                :page-sizes="[10, 20, 30, 40]"
                :page-size="searchFrom.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 弹窗 -->
        <div class="popup-view">
            <el-form label-position="top" label-width="100px" :model="upform" :rules="rules" ref="upform">
                <el-dialog
                :title="popupTitle == 0?'新增模块':'修改模块'"
                v-model="centerDialogVisible"
                width="50%"
                @close='closeDialog'>
                <!-- 图标展示 -->
                <div class="popup-view">
                    <el-dialog
                        width="30%"
                        title="内弹窗"
                        v-model="innerVisible"
                        append-to-body>
                        <template #footer>
                            <el-form-item>
                                <el-button class="cancel" plain @click="innerVisible = false" round>取消</el-button>
                                <el-button class="confirmAdd" round>确认</el-button>
                            </el-form-item>
                        </template>
                    </el-dialog>
                </div>
                <div class="center-body">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="模块名称：" prop="name">
                                <el-input v-model="upform.name" placeholder="请输入内容"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="模块根菜单id：" prop="rootMenu">
                                <el-input v-model="upform.rootMenu" placeholder="请输入内容"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="模块单价：" prop="price">
                                <el-input v-model="upform.price"  placeholder="请输入保留两位小数的金额" oninput="value=value.replace(/[^0-9.]/g,'')">
                                    <template #append>￥</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="模块备注：">
                                <el-input
                                type="textarea"
                                placeholder="请输入内容"
                                :autosize="{ minRows: 4, maxRows: 6}"
                                v-model="upform.remark"
                                maxlength="30"
                                show-word-limit
                                >
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <template #footer>
                        <el-form-item>
                            <el-button class="cancel" plain @click="resetForm('upform')" round>取消</el-button>
                            <el-button class="confirmAdd" @click="submitForm('upform')" round>{{ popupTitle == 0 ? '新增' : '修改' }}</el-button>
                        </el-form-item>
                </template>
                </el-dialog>
            </el-form>
        </div>
    </div>
</template>

<script>
import userModule from '@/api/web/userModule'
import { IconFont } from "@/utils/iconfont"
export default {
    components: {
        IconFont,
    },
    data () {
        const validatePrice = (rule,value,callback) =>{
            let reg = /^(([1-9]{1}\d*)|(0{1}))$/
            if(!value){
                callback(new Error('单价不能为空'))
            }else if(!reg.test(value)){
                callback(new Error('请输入正确的金额格式'))
            }else if(value.length > 10){
                callback(new Error('最多可输入10个字符'))
            }else{
            callback();
            }
        };
        return {
            tableHeight:'',
            searchFrom:{
                page:1,
                pageSize:10,
                name:'',
                status:'',
                createTimeBegin:'',
                createTimeEnd:'',
            },//搜索值
            statusName:'启用',
            currentPage: 1,//分页
            total:0,
            multipleSelection: [],//选中集合
            treeList:[],//部门列表
            value:'',//所属部门
            valueTime:'',//选中时间段
            defaultTime: [
                new Date(2000, 1, 1, 12, 0, 0),
                new Date(2000, 2, 1, 8, 0, 0)
            ], //默认时间 '12:00:00', '08:00:00'
            activeNames: [],//折叠面板
            tableData: [],//数据列表
            loading: true,// loding 状态启用
            popupTitle:0,//弹窗类别
            centerDialogVisible: false,//弹窗启用
            innerVisible: false,//图标弹窗启用
            upform: {//模块信息
                name: '',//模块名称
                rootMenu: '',
                price:'',//所属部门
                remark: '',//模块备注
            },
            rules: {
                name: [
                    { required: true, message: '请输入模块名称', trigger: 'blur' },
                    { min: 2, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur' }
                ],
                rootMenu: [
                    { required: true, message: '请输入模块根菜单id', trigger: 'blur' },
                ],
                price: [
                    {required: true,  trigger: 'blur', validator:validatePrice}
                ],
            }
        }
    },
    created() {
        this.tableHeight = this.$store.state.tableHeight
    },
    watch: {

    },
    mounted() {
        this.getDataList(true)
        // this.getDepartmentTree()
    },
    methods: {
        // 重置
        reset() {
            this.valueTime = []
            this.statusName = '启用'
            this.searchFrom = {
                page: this.currentPage,
                pageSize: 10,  
            }
            this.getDataList(true)
        },
        // 获取部门树
        // getDepartmentTree(){
        //     department.getDepartmentTree({}).then((res) => {
        //         this.treeList = res.data
        //     })
        // },
        // 获取模块列表
        getDataList(type) {
            this.loading = type
            this.searchFrom.createTimeBegin = this.valueTime[0]
            this.searchFrom.createTimeEnd = this.valueTime[1]
            this.statusName == '启用'?this.searchFrom.status = '0':this.searchFrom.status = '1'
            userModule.userModuleList({
                ...this.searchFrom
            }).then((res) => {
                this.tableData = res.data.records
                this.total = res.data.total
                this.loading = false
            })
        },
        // 分页
        handleSizeChange(val) {
            this.searchFrom.pageSize = val
            this.getDataList(true)
            console.log(this.currentPage)
        },
        handleCurrentChange(val) {
            this.searchFrom.page = val
            this.currentPage = val
            this.getDataList(true)
        },
        // 折叠面板
        handleChange(val) {
            console.log(val);
        },
        // 多选
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 批量删除
        deleteData() {
            console.log(this.multipleSelection)
        },
        // 新增
        addData(){
            this.popupTitle = 0
            this.centerDialogVisible = true
        },
        // 控制状态
        onSwitch(row, status){
            app.editApp({
                id:row.id,
                status: status == 0 ? 0 : 1
            }).then((res) => {
                this.$notify({
                    title: '成功',
                    message: status == 0 ? '该模块启用成功！' : '该模块禁用成功！',
                    type: 'success'
                });
                this.getDataList(false)
                this.centerDialogVisible = false
            })
        },
        // 修改
        modify(row) {
            // 获取当前行详情
           this.upform = JSON.parse(JSON.stringify(row))
            this.popupTitle = 1
            this.centerDialogVisible = true
        },
        // 删除确认
        confirmEvent(id) {
            this.$confirm('将删除该模块, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                app.deleteApp({
                    id:id
                }).then((res) => {
                    this.$notify({
                        title: '成功',
                        message: '模块删除成功！',
                        type: 'success'
                    });
                    this.getDataList(true)
                })
            }).catch(() => {
                this.$notify.info({
                    title: '通知',
                    message: '已取消删除!'
                });
            });
        },
        // 取消
        cancelEvent() {
            console.log("cancel!");
        },
        // 表单提交
        submitForm(formName) {
            this.upform.departmentId = this.value[this.value.length-1]
            this.$refs[formName].validate((valid) => {
            if (valid) {
                if( this.popupTitle == 0 ){
                    app.addApp({
                        ...this.upform
                    }).then((res) => {
                        this.$notify({
                            title: '成功',
                            message: '模块添加成功！',
                            type: 'success'
                        });
                        this.getDataList(true)
                        this.centerDialogVisible = false
                    })
                }else{
                    app.editApp({
                        ...this.upform
                    }).then((res) => {
                        this.$notify({
                            title: '成功',
                            message: '模块修改成功！',
                            type: 'success'
                        });
                        this.getDataList(true)
                        this.centerDialogVisible = false
                    })
                }
            } else {
                // console.log('error submit!!');
                return false;
            }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.value = []
            this.centerDialogVisible = false
        },
        closeDialog() {
            this.$refs.upform.resetFields()
            this.value = []
            this.centerDialogVisible = false
        },
    }
}
</script>

<style lang="scss" scoped>
.pager {
    display: flex;
    justify-content: flex-end;
}
.jobs{
    height: 100%;
    overflow-y: overlay;
    padding-right: 18px;
    .title-name{
        font-size: .9375rem;
        font-weight: 600;
        color: #303133;
    }
    .top-first{
        .search-box{
            width: 18.75rem;
        }
    }
}
.screening{
    margin-bottom: .9375rem;
}
.el-row {
    margin-bottom: .9375rem;
    &:last-child {
        margin-bottom: 0;
    }
}
.space-tile{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
}
.title-buttom{
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
}
.editor{
    color: #0170ED;
    background: #E3F0FF;
}
.center-body{
    margin: 0 1.875rem;
}
.deletetable{
    color: #FF845B;
    background: #FFE4DB;
}
.deletetable-other{
    margin-right: 1.25rem;
}
.confirmAdd{
    background: #637DFF;
    color: #fff;
}
.cancel{
    color: #637DFF;
    border: #637DFF solid 1px;
}
.screening-out{
    margin: 0 .9375rem;
}
.showIcon{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    overflow-y: overlay;
    height: 28.125rem;
    .out-icon{
        border-radius: .5rem;
        .icon-box{
            display: flex;
            justify-content: space-between;
            align-items: center;
            justify-content: center;
            width:  4rem;
            height: 3rem;
        }
        .icon-name{
            text-align: center;
            width: 4rem;
            height: 2.5rem;
            line-height: 2.5rem;
            
        }
    }
    
}
.out-icon:hover{
    background: #E3F0FF;
    color: #0170ED;
}
</style>

<style lang="scss">
.jobs .el-collapse-item__content {
    padding-bottom: 0 !important;
}
// .jobs .el-button {
//     // border-color: #FFFFFF !important;
// }
</style>